<template>
  <NuxtImg
    src="https://cdn-assets.boostingmarket.com/icons/arrow-right.svg"
    width="16"
    height="16"
    alt="message icon"
  />
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
